import React from "react";
import { Box, Heading, Flex, Text, Button } from "@chakra-ui/react";
import { IConfigureStep } from "./types";

const defaultGoBackLabel = "Go Back";
const defaultNextLabel = "Next";

const ConfigureStep: React.FC<IConfigureStep> = (props: IConfigureStep) => {
  const {
    buttonGoBack,
    buttonGoBackLabel = defaultGoBackLabel,
    buttonGoBackOnclick,
    buttonNext,
    buttonNextDisabled = false,
    buttonNextLabel = defaultNextLabel,
    buttonNextOnclick,
    StepComponent,
    step,
    description,
    title,
    onConfirmation,
    finished,
  } = props;

  return (
    <>
      <Box pb="48px" pt="48px">
        <Heading fontSize={finished ? "32px" : "24px"} mb="16px">
          {title}
        </Heading>
        <Text mb="32px">{description}</Text>
        <Flex
          justifyContent="flex-start"
          borderWidth="2px"
          borderStyle="solid"
          borderColor="black"
        >
          <StepComponent step={step} onConfirmation={onConfirmation} />
        </Flex>
        <Flex pt="8">
          {buttonGoBack && (
            <Button
              variant="outline"
              bg="white"
              h="48px"
              w="180px"
              {...(buttonGoBackOnclick && {
                onClick: () => buttonGoBackOnclick(),
              })}
            >
              {buttonGoBackLabel}
            </Button>
          )}
          {buttonNext && (
            <Flex
              w="100%"
              justifyContent="flex-end"
              {...(buttonNextOnclick && { onClick: () => buttonNextOnclick() })}
            >
              <Button variant="solid" h="48px" disabled={buttonNextDisabled}>
                {buttonNextLabel}
              </Button>
            </Flex>
          )}
        </Flex>
      </Box>
    </>
  );
};

export default ConfigureStep;
